import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";
import {useSelector} from "react-redux";


export const usePozycjeSlownika = (slownik, enabled = true) => {
    const role = useSelector(state => state.user.role);
    const roleParame = role === 'oper' ? 'oper' : '';

    return useQuery({
        queryKey: [`pozycje_slownika__${slownik}`],
        queryFn: () => getList(`${roleParame}/slowniki/${slownik}`),
        enabled: enabled
    })
}